import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
} from "antd";
import { NetWorkApi } from "@/services/fetch";
import { useMemoizedFn } from "ahooks";
import { setEeSystemConfig, UserInfoProps } from "@/store";
import yakitImg from "@/assets/yakit.jpg";
import { API } from "@/services/swagger/resposeType";
import { useHistory } from "react-router-dom";
import styles from "./YakitLogin.module.scss";
import { setUserInfo } from "@/services/state";
import storageUtils from "@/utils/storageUtils";
import md5 from "md5";

export const defaultUserInfo: UserInfoProps = {
  isLogin: false,
  platform: null,
  githubName: null,
  githubHeadImg: null,
  wechatName: null,
  wechatHeadImg: null,
  qqName: null,
  qqHeadImg: null,
  companyName: null,
  companyHeadImg: null,
  role: null,
  user_id: null,
  token: "",
  checkPlugin: false,
};

interface OnlineProfileProps {
  BaseUrl: string;
  Proxy: string;
  user_name: string;
  pwd: string;
}

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

interface YakitLoginProps {
  onClose?: () => void;
  onSuccee?: () => void;
}

export const YakitLogin: React.FC<YakitLoginProps> = React.memo((props) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const storeUser = storageUtils.getUserLoginInfo();

    if (storeUser.token && storeUser.token.length > 0) {
      // 通过token获取用户信息
      NetWorkApi<API.UserInfoByToken, API.UserData>({
        method: "post",
        url: "auth/user",
        data: {
          token: storeUser.token,
        },
      })
        .then((res) => {
          const user = {
            isLogin: true,
            platform: res.from_platform,
            githubName: res.from_platform === "github" ? res.name : null,
            githubHeadImg: res.from_platform === "github" ? res.head_img : null,
            wechatName: res.from_platform === "wechat" ? res.name : null,
            wechatHeadImg: res.from_platform === "wechat" ? res.head_img : null,
            qqName: res.from_platform === "qq" ? res.name : null,
            qqHeadImg: res.from_platform === "qq" ? res.head_img : null,
            companyName: res.from_platform === "company" ? res.name : null,
            companyHeadImg:
              res.from_platform === "company" ? res.head_img : null,
            role: res.role,
            user_id: res.user_id,
            token: storeUser.token,
            checkPlugin: res?.checkPlugin || false,
          };
          setUserInfo(user); // 保存在内存中
          storageUtils.saveUserLoginInfo(user); // 保存在Local中
          message.success("企业登录成功");
          history.push("/admin/user");
        })
        .catch((err) => {})
        .finally(() => {});
    }
  }, []);
  const onFinish = useMemoizedFn((v: OnlineProfileProps) => {
    setLoading(true);
    const values = {
      ...v,
      IsCompany: true,
    };
    NetWorkApi<API.UrmLoginRequest, API.UserData>({
      method: "post",
      url: "urm/login",
      data: {
        user_name: values.user_name,
        pwd: md5(values.pwd),
      },
    })
      .then((res: API.UserData) => {
        const user = {
          isLogin: true,
          platform: res.from_platform,
          githubName: res.from_platform === "github" ? res.name : null,
          githubHeadImg: res.from_platform === "github" ? res.head_img : null,
          wechatName: res.from_platform === "wechat" ? res.name : null,
          wechatHeadImg: res.from_platform === "wechat" ? res.head_img : null,
          qqName: res.from_platform === "qq" ? res.name : null,
          qqHeadImg: res.from_platform === "qq" ? res.head_img : null,
          companyName: res.from_platform === "company" ? res.name : null,
          companyHeadImg: res.from_platform === "company" ? res.head_img : null,
          role: res.role,
          user_id: res.user_id,
          token: res.token,
          checkPlugin: res?.checkPlugin || false,
        };

        setUserInfo(user); // 保存在内存中
        storageUtils.saveUserLoginInfo(user); // 保存在Local中
        message.success("企业登录成功");
        history.push("/admin/user");

        NetWorkApi<any, API.SystemConfigResponse>({
          method: "get",
          url: "system/config",
        }).then((config) => {
          const data = config.data || [];
          setEeSystemConfig([...data]);
        });
      })
      .catch((err) => {
        setTimeout(() => setLoading(false), 300);
        message.error("企业登录失败：" + err);
      })
      .finally(() => {});
  });

  // 判断输入内容是否通过
  const judgePass = () => [
    {
      validator: (_: any, value: any) => {
        let re =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.<>?;:\[\]{}~!@#$%^&*()_+-="])[A-Za-z\d.<>?;:\[\]{}~!@#$%^&*()_+-="]{8,20}/;
        if (re.test(value)) {
          return Promise.resolve();
        } else {
          return Promise.reject(
            "密码为8-20位，且必须包含大小写字母、数字及特殊字符"
          );
        }
      },
    },
  ];

  return (
    <div className={styles["yakit-login"]}>
      <div className={styles["private-domain"]}>
        <div className={styles["login-title-show"]}>
          <div className={styles["icon-box"]}>
            <img src={yakitImg} className={styles["type-icon-img"]} />
          </div>
          <div className={styles["title-box"]}>企业登录</div>
        </div>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={(v) => onFinish(v)}
          size="small"
        >
          <Form.Item
            name="user_name"
            label="用户名"
            rules={[{ required: true, message: "该项为必填" }]}
          >
            <Input placeholder="请输入你的用户名" allowClear />
          </Form.Item>

          <Form.Item
            name="pwd"
            label="密码"
            rules={[{ required: true, message: "该项为必填" }, ...judgePass()]}
          >
            <Input.Password placeholder="请输入你的密码" allowClear />
          </Form.Item>

          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: 165, height: 30 }}
              loading={loading}
            >
              登录
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
});
